import { PropsWithChildren } from 'react'

import { cn } from '@/utils/tailwind'

export const CallButton = ({
  children,
  onClick,
  className,
  enabled = true
}: PropsWithChildren<{
  onClick: () => void
  className?: string
  enabled?: boolean
}>) => {
  return (
    <button
      className={cn(
        'flex aspect-square h-15 cursor-pointer items-center justify-center rounded-full bg-white text-black shadow-sm',
        !enabled && 'bg-white/50',
        className
      )}
      aria-pressed={enabled}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
